import React from "react";
import Loader from "../../../Loader/Loader";
import { FaUserPlus } from "react-icons/fa";
import { useEvent } from "../../../../context/EventContext";
import eventsAPI from "../../../../api/eventsAPI";
import { useAuth } from "../../../../context/AuthContext";

// * ProfilePage is a component that displays the details of a selected user
// * in a modal. The details include the user's name, email, age, gender, and
// * job status. It also displays the connection status of the user with the
// * current user. The connection status can be "Connection Request Accepted",
// * "Connection Request Pending", "No Connection", or "Connection Request
// * Rejected". The component also allows the user to send a connection request
// * to the selected user by clicking on the "Connect" button. The component
// * also displays a "Back" button to go back to the previous page.
const ProfilePage = ({ setShowMessage, selectedUser }) => {
  const {
    loading,
    connStatus,
    handleConnect,
    setConnStatus,
    setSelectedUser,
    setLoading,
  } = useEvent();

  const { user } = useAuth();

  //   * Handles the "Back" button click by setting the showMessage state to false
  //   * and resetting the selectedUser state to null. This goes back to the previous
  //   * page.
  const handleBackClick = () => {
    setShowMessage(false);
    setSelectedUser(null); // Reset selected user data
  };

  const handleRemoveConnection = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await eventsAPI.post("/data/disconnect", {
        senderId: user.id,
        receiverId: selectedUser._id,
      });

      if (response.status === 200) {
        setSelectedUser(null); // Reset selected user data
        setShowMessage(false); // Close the modal
        setLoading(false);
        setConnStatus("No Connection");
      } else {
        console.log("Failed to remove connection");
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  return (
    <div className="user-profile">
      <div className="user-image">
        <img
          src={selectedUser.profilePicture}
          alt={`${selectedUser.firstName}'s profile`}
          //   style={{ width: "100px", borderRadius: "50%" }}
        />
      </div>
      <div className="user-data">
        <p>
          <strong>Name:</strong> {selectedUser.firstName}{" "}
          {selectedUser.lastName}
        </p>
        <p>
          <strong>Email:</strong> {selectedUser.email}
        </p>
        <p>
          <strong>Job Status:</strong> {selectedUser.jobStatus}
        </p>
        <p>
          <strong>Age: </strong>
          {selectedUser.age}
        </p>
        <p>
          <strong>Gender:</strong> {selectedUser.gender}
        </p>
        <div className="user-buttons">
          {connStatus ? (
            <span>
              {
                connStatus === "Connection Request Accepted" ? (
                  <>
                    <span
                      style={{
                        color: "green",
                        fontWeight: "bold",
                        fontSize: "20px",
                      }}
                    >
                      Connection Accepted
                    </span>
                    <button
                      onClick={(e) => handleRemoveConnection(e)}
                      className="add-space"
                    >
                      Remove Connection
                    </button>
                  </>
                ) : connStatus === "Connection Request Pending" ? (
                  <span
                    style={{
                      color: "blue",
                      fontWeight: "bold",
                      fontSize: "20px",
                    }}
                  >
                    Request Pending
                  </span>
                ) : connStatus === "No Connection" ? (
                  <button
                    className="add-space"
                    onClick={(e) => handleConnect(e)}
                  >
                    {loading ? (
                      <Loader />
                    ) : (
                      <>
                        <FaUserPlus /> Connect
                      </>
                    )}
                  </button>
                ) : null /* Handle any other unexpected statuses */
              }
            </span>
          ) : (
            // Default case: when no connStatus is provided, show the "Connect" button
            <button className="add-space" onClick={(e) => handleConnect(e)}>
              {loading ? (
                <Loader />
              ) : (
                <>
                  <FaUserPlus /> Connect
                </>
              )}
            </button>
          )}
          <button className="add-space" onClick={handleBackClick}>
            Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
